import { useQuery } from "admin/src/hooks/useQuery";
import React from "react";
import { Link } from "react-router-dom";
import LoadingTable from "../../shared/LoadingTable";
import { ThemeType } from "../../types/index";
import { capitalize } from "../../utils/wordUtils";

type TableProps = {
	className?: string;
	theme?: ThemeType;
	children?: React.ReactNode;
	title?: string;
	icon?: string;
	iconColor?: string;
	total: number;
	to?: string;
	loading?: boolean;
	onPageChange?: (page: number) => void;
};

const defaultProps = {
	className: "",
	theme: "light",
	total: 0,
};

const Table = ({
	theme,
	children,
	className,
	title,
	icon,
	iconColor,
	total,
	to,
	loading,
	onPageChange = () => {},
}: TableProps): JSX.Element => {
	const [page, setPage] = useQuery();
	return (
		<div
			className={`relative shadow-lg flex flex-col min-w-0 break-words w-full rounded  ${className} ${
				theme === "light" ? "bg-white" : "bg-blueGray-700 text-white"
			} `}
		>
			<div>
				<div className="rounded-t mb-0 border-0">
					<div className="flex flex-wrap items-center">
						<div className="relative w-full px-6 py-4 max-w-full flex justify-between flex-grow flex-1">
							<div className="flex items-center">
								{icon && <i className={`${icon} ${iconColor} mr-3`} />}
								<h3
									className={`
                  font-semibold text-md
                  ${theme === "light" ? "text-blueGray-700" : "text-white"}
                  ${iconColor}
                  className
                `}
								>
									{capitalize(title || "table")}
								</h3>
							</div>
							{total ? (
								<></>
							) : (
								<Link
									to={to || "/dashboard"}
									className="bg-sky-500 text-white active:bg-sky-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
									type="button"
								>
									See all
								</Link>
							)}
						</div>
					</div>
				</div>
			</div>
			{loading ? <LoadingTable /> : children}
			{page && (
				<div className="grid grid-flow-col gap-x-1 justify-end pb-3 pr-3">
					{Array.from(Array(Math.ceil(total / 10))).map((v, i, arr) => {
						if (
							parseInt(page.get("page") || "1") === i + 1 ||
							i === 0 ||
							i === arr.length - 1 ||
							i === parseInt(page.get("page") || "1") - 2 ||
							i === parseInt(page.get("page") || "1")
						) {
							return (
								<div key={i}>
									<button
										className={`${
											parseInt(page.get("page") || "1") === i + 1
												? "bg-sky-500"
												: "bg-sky-300"
										} text-white text-xs px-2 py-1 rounded-md`}
										onClick={() => {
											setPage("page", (i + 1).toString());
											onPageChange(i + 1 || 1);
										}}
									>
										{i + 1}
									</button>
								</div>
							);
						} else {
							return <div key={i} className="hidden"></div>;
						}
					})}
				</div>
			)}
		</div>
	);
};

Table.defaultProps = defaultProps;

export default Table;
